function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Display Data");

var SvgDisplay = function SvgDisplay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("path", {
    d: "M82.28,25h-67a4,4,0,0,0-4,4v40.8a4,4,0,0,0,4,4h67a4,4,0,0,0,4-4V29A4,4,0,0,0,82.28,25Zm-67.93,4.6a.52.52,0,0,1,.53-.52H38a.52.52,0,0,1,.52.52v4a.52.52,0,0,1-.52.53H14.88a.53.53,0,0,1-.53-.53Zm0,17.9a.6.6,0,0,1,.6-.6H45.28a.6.6,0,0,1,.6.6v3.8a.6.6,0,0,1-.6.6H15a.6.6,0,0,1-.6-.6Zm69.3,21.34a.88.88,0,0,1-.89.88H15.24a.88.88,0,0,1-.89-.88V65.65a.89.89,0,0,1,.89-.89H82.76a.89.89,0,0,1,.89.89Zm0-8.92a.89.89,0,0,1-.89.89H15.24a.89.89,0,0,1-.89-.89V56.74a.89.89,0,0,1,.89-.89H82.76a.89.89,0,0,1,.89.89ZM48,51.31V47.58a.64.64,0,0,1,.64-.64H82.81a.64.64,0,0,1,.63.64v3.73a.63.63,0,0,1-.63.63H48.64A.63.63,0,0,1,48,51.31Zm35.65-9.17a.89.89,0,0,1-.89.89H15.24a.89.89,0,0,1-.89-.89V38.92a.89.89,0,0,1,.89-.89H82.76a.89.89,0,0,1,.89.89Zm0-8.72a.71.71,0,0,1-.7.7H41.29a.7.7,0,0,1-.7-.7v-3.6a.7.7,0,0,1,.7-.7H83a.7.7,0,0,1,.7.7Z",
    style: {
      fill: "#ccc"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDisplay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DISPLAY.189ea3dc.svg";
export { ForwardRef as ReactComponent };